import axios from 'axios';

const ep_set_permit_bsims = `${process.env.VUE_APP_PB_API}/ags/permit/set_permit`;
const ep_list_set_permit = `${process.env.VUE_APP_PB_API}/ags/permit/list-set-permit`;
const ep_retry_set_permit = `${process.env.VUE_APP_PB_API}/ags/permit/api_set_permit`;

const setPermitBsims = (data) => {
    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: ep_set_permit_bsims,
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data),
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const listSetPermit = (data) => {
    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${ep_list_set_permit}?page=${data.current_page}`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data),
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const retrySetPermit = (data) => {
    let payload = {
        cont_no: data.cont_no,
        id_trans: data.bsims_id,
        in_out: data.kd_transaksi,
        no_pol: data.lic_plate,
        id_gatepass: data.qr_code,
    }

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${ep_retry_set_permit}`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

export {setPermitBsims, listSetPermit, retrySetPermit}